export default __webpack_public_path__ + "static/media/responsive.6c0872da.png";